<template>
  <b-container
    v-if="isPanelOpen"
    ref="saleSidePanel"
    class="panel-right"
    :style="{ backgroundColor: panelBackground }"
  >
    <b-row>
      <b-col>
        <h2>Edição de parcelas</h2>
      </b-col>
    </b-row>

    <b-row
      v-for="(installment, index) in installments"
      :key="index"
      class="installment-item p-3 mb-3"
    >
      <b-col>
        <b-row>
          <b-col>
            <h4>Parcela {{ installment.installmentNumber }}</h4>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Data de Vencimento:">
              <b-form-input
                type="date"
                v-model="installment.dueDate"
                :disabled="isLastInstallment(index)"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Valor:">
              <b-form-input
                type="number"
                v-model.number="installment.installmentValue"
                min="0"
                max="100"
                @input="adjustLastInstallment(index)"
                :disabled="isLastInstallment(index)"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Percentual:">
              <b-form-input
                type="number"
                v-model.number="installment.installmentPercent"
                min="0"
                max="100"
                @input="adjustValue(index)"
                :disabled="isLastInstallment(index)"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Nota:">
              <b-form-textarea
                v-model="installment.observations"
                rows="2"
                :disabled="isLastInstallment(index)"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-button variant="primary" class="mt-3" @click="saveInstallments"
      >Salvar Alterações</b-button
    >
  </b-container>
</template>

<script>
export default {
  name: "SaleSidePanel",
  props: {
    isPanelOpen: Boolean,
    totalAmount: Number,
    installments: []
  },
  watch: {
    isPanelOpen(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.listening = true;
            document.addEventListener("click", this.handleClickOutside);
          }, 100);
        });
      } else {
        this.listening = false;
        document.removeEventListener("click", this.handleClickOutside);
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    panelBackground() {
      return this.$store.state.darkmode ? "#222a42" : "#FFFFFF";
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if (
        this.isPanelOpen &&
        this.$refs.saleSidePanel &&
        !this.$refs.saleSidePanel.contains(event.target)
      ) {
        this.$emit("close-saleSidepanel");
      }
    },
    saveInstallments() {
      this.$emit("update-installments", this.installments);
      alert("Alterações salvas com sucesso!");
    },
    isLastInstallment(index) {
      return index === this.installments.length - 1;
    },
    adjustLastInstallment(index) {
      this.installments.forEach((i, idx) => {
        if (idx != index) {
          i.installmentValue = i.initialStateValue;
        }
      });

      var surplus = parseFloat(
        (
          this.totalAmount -
          this.installments.reduce(function(sum, installment) {
            return sum + installment.installmentValue;
          }, 0)
        ).toFixed(2)
      );

      this.installments
        .slice()
        .reverse()
        .forEach((installment, index) => {
          const originalIndex = this.installments.length - 1 - index;

          this.installments[originalIndex].installmentValue =
            installment.installmentValue + surplus;

          this.installments[originalIndex].installmentValue = Math.max(
            0,
            this.installments[originalIndex].installmentValue
          );

          this.installments[originalIndex].installmentPercent =
            ((this.installments[originalIndex].installmentValue /
              this.totalAmount) *
            100).toFixed(2);

          surplus = parseFloat(
            (
              this.totalAmount -
              this.installments.reduce(function(sum, installment) {
                return sum + installment.installmentValue;
              }, 0)
            ).toFixed(2)
          );
        });
    },
    adjustValue(index) {
      this.installments[index].installmentValue =
        (this.installments[index].installmentPercent / 100) * this.totalAmount;
      this.adjustLastInstallment(index);
    }
  }
};
</script>

<style scoped>
.panel-right {
  position: fixed;
  top: 0;
  right: 0;
  width: 45vw;
  height: 100%;
  background-color: #00163f;
  z-index: 1050;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
  padding: 20px;
  overflow-y: auto;
}
.panel-content {
  position: relative;
}
button {
  margin-top: 10px;
}
body {
  transition: margin-right 0.9s ease;
  color: #ffffff !important;
}
.panel-right.show {
  margin-right: 300px;
}
</style>
